import React from 'react'
import GitstreamSvg from '../icons/gitstream.svg?react'

interface GitstreamIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number
  height?: number
}

const GitstreamIcon = React.forwardRef<SVGSVGElement, GitstreamIconProps>(
  ({ width = 20, height = 20, ...props }, ref) => (
    <GitstreamSvg {...props} ref={ref} width={width} height={height} />
  )
)

GitstreamIcon.displayName = 'GitstreamIcon'

export default GitstreamIcon
